/* 🤖 this file was generated by script */
export const wsolidiconLightning02 = {
  name: 'lightning_02',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M8.5 1h-.04c-.13 0-.4 0-.64.08q-.32.12-.56.35c-.19.18-.3.42-.36.53L6.88 2l-4.21 8.42-.24.5a1.5 1.5 0 0 0 .51 1.8c.29.2.59.25.76.26q.27.02.56.02h4.9l-2.62 8.71a1 1 0 0 0 1.68.98l12.22-12.67q.28-.28.5-.54c.12-.15.35-.46.38-.88a1.5 1.5 0 0 0-.53-1.25 1.6 1.6 0 0 0-.9-.33q-.32-.03-.74-.02h-5.7l1.74-4.65A1 1 0 0 0 14.25 1z"/></svg>`,
  iconStyle: 'solid',
};
